import { useEffect, useState } from "react";
import type { Objective } from "../types";
import { getStages } from "../lib/resources";

type ObjectiveFilterProps = {
  objectives: Objective[];
  selectedStage: string | null;
  selectedObjective: string | null;
  onSelectStage: (stage: string | null) => void;
  onSelectObjective: (objectiveId: string | null) => void;
};

export function ObjectiveFilter({
  objectives,
  selectedStage,
  selectedObjective,
  onSelectStage,
  onSelectObjective
}: ObjectiveFilterProps) {
  const stages = getStages({ version: 1, objectives, enablers: [], resources: [] });
  const [openStage, setOpenStage] = useState<string | null>(selectedStage);

  useEffect(() => {
    setOpenStage(selectedStage);
  }, [selectedStage]);

  return (
    <section className="filter-group" aria-label="Key objective filter">
      <span className="filter-group__label">Key objective</span>
      <div className="enabler-filter">
        <div className="filter-group__options">
          <button
            className={selectedStage === null && selectedObjective === null ? "pill pill--active" : "pill"}
            type="button"
            onClick={() => {
              onSelectStage(null);
              onSelectObjective(null);
              setOpenStage(null);
            }}
          >
            All
          </button>
          {stages.map((stage) => (
            <button
              className={selectedStage === stage && selectedObjective === null ? "pill pill--active" : "pill"}
              type="button"
              key={stage}
              onClick={() => {
                const nextStage = selectedStage === stage && selectedObjective === null ? null : stage;
                onSelectStage(nextStage);
                onSelectObjective(null);
                setOpenStage(nextStage);
              }}
            >
              {stage}
            </button>
          ))}
        </div>

        {selectedStage ? (
          <div className="enabler-filter__theme">
            <button
              className="enabler-filter__toggle"
              type="button"
              aria-expanded={openStage === selectedStage}
              onClick={() => setOpenStage((stage) => (stage === selectedStage ? null : selectedStage))}
            >
              <span>{selectedStage} key objectives</span>
              <span aria-hidden="true">{openStage === selectedStage ? "Hide" : "Show"}</span>
            </button>
            {openStage === selectedStage ? (
              <div className="filter-group__options">
                {objectives
                  .filter((objective) => objective.stage === selectedStage)
                  .map((objective) => (
                    <button
                      className={selectedObjective === objective.id ? "pill pill--active" : "pill"}
                      type="button"
                      key={objective.id}
                      onClick={() => onSelectObjective(selectedObjective === objective.id ? null : objective.id)}
                    >
                      {objective.code} {objective.title}
                    </button>
                  ))}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </section>
  );
}
